import type { ApiLeadPhone } from '@/api/conversations/types/index.ts';
import Model from './Model.js';

export type { ApiLeadPhone } from '@/api/conversations/types/index.ts';

export default class ConversationLeadPhone extends Model {
    declare id: number;

    declare phone: string;

    declare type: string | null;

    declare preferred: boolean | null;

    static get defaults() {
        return {
            id: 0,
            phone: '',
            type: null,
            preferred: false,
        };
    }

    static fromApi(leadPhone: ApiLeadPhone): ConversationLeadPhone {
        return new ConversationLeadPhone({
            id: leadPhone.id,
            phone: leadPhone.phone,
            type: leadPhone.type || null,
            preferred: leadPhone.preferred,
        });
    }

    constructor(initialValues: Partial<ConversationLeadPhone> = {}) {
        super(initialValues);
    }
}
